import axios from 'axios';
import { SET_HELP_CURRENTPAGE, SET_MENU_OPTIONS, SAVE_SECURITY,
         SET_SECURITY, SET_CONSTANTS, SAVE_CACHE, RESET_SECURITY, SAVE_WIDGETS } from './types';

export const newPage = (data, securityCache, path) => dispatch => {
    let sCache = securityCache;
    let security = data.security;
    security.path = path;
    security._help = data.help || {};
    sCache.push(security);
    dispatch(saveSecurity(security, sCache));
    dispatch({ type: SET_HELP_CURRENTPAGE, payload: { current: security._help } });
};

// Internal/admin screens are gated by user.internal in DynamicRoute, not by a
// screenaccess record. Grant full access locally instead of calling the
// screenaccess endpoint (which would 412 for these paths).
export const internalPage = (path, securityCache) => dispatch => {
    let sCache = securityCache;
    const security = {
        approve: true, complete: true, create: true, delete: true,
        read: true, review: true, unlock: true, update: true,
        print: true, documentDelete: true, documentUpload: true,
        path, _help: {}
    };
    sCache.push(security);
    dispatch(saveSecurity(security, sCache));
    dispatch({ type: SET_HELP_CURRENTPAGE, payload: { current: security._help } });
};

export const changePage = (path, securityCache) => dispatch => {
  let sCache = securityCache;
  let currentSecurity = sCache.find(security => security.path === path);
  dispatch(setSecurity(currentSecurity));
  dispatch({ type: SET_HELP_CURRENTPAGE, payload: { current: currentSecurity?._help || {} } });
};

export const getWidgetPermissions = (widgets, cache) => async dispatch => {
  let data = [];
  let missingWidgets = widgets;
  let newWidgets = [];
  
  if(cache != null && cache.length > 0){
    const existing = cache.filter(x => widgets.includes(x.widget));
    data.push(...existing);
    
    // Find which widgets are missing from cache
    const cachedWidgetIds = existing.map(x => x.widget);
    missingWidgets = widgets.filter(w => !cachedWidgetIds.includes(w));
  }
  
  // Only call API if we have missing widgets
  if(missingWidgets.length > 0) {
    const result = await axios.post('/api/widgetaccess/', {
      widgets: missingWidgets
    });
    
    // Add API results to our data and track new widgets
    if(result.data && result.data.length > 0) {
      newWidgets = result.data;
      data.push(...newWidgets);
    }
  }
  
  // Only save NEW widgets to store to prevent duplicates
  // Cached widgets are already in the store
  if(newWidgets.length > 0) {
    // Deduplicate new widgets just in case API returns duplicates
    const uniqueNewWidgets = newWidgets.filter((item, index, self) => 
      index === self.findIndex(t => t.widget === item.widget)
    );
    dispatch(saveWidgets(uniqueNewWidgets));
  }
  
  return data;
}

export const removePath = (path, cache) => dispatch => {
  let existingCache = cache;
  const index = existingCache.findIndex(screen => screen.path === path);
  if(index !== -1){
    existingCache.splice(index, 1);
    dispatch(saveCache(existingCache));
  }
}

export const setMenuOptions = menuOptions => ({
  type: SET_MENU_OPTIONS,
  payload: {
    menuOptions: menuOptions
  }
});

export const saveCache = cache => ({
  type: SAVE_CACHE,
  payload: {
    cache: cache
  }
})

export const saveSecurity = (current, cache) => ({
  type: SAVE_SECURITY,
  payload: {
    current: current,
    cache: cache
  }
});

export const saveWidgets = widgets => ({
  type: SAVE_WIDGETS,
  payload: {
    widgets: widgets
  }
});

export const setSecurity = current => ({
  type: SET_SECURITY,
  payload: {
    current: current
  }
});

export const setConstants = tenant => ({
  type: SET_CONSTANTS,
  payload: {
    tenant: tenant
  }
});

export const resetSecurity = () => ({
  type: RESET_SECURITY,
});
